import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { SessionController } from 'src/app/auth/session/session-controller';

import { DASHBOARD_ROUTE } from './auth.guard';

/**
 * Guards the login page: a user who can already enter the app has no business there and is sent to
 * the dashboard. The decision is SessionController.isAuthenticated, the predicate AuthGuard applies
 * on the other side (#26615).
 */
@Injectable({ providedIn: 'root' })
export class NoAuthGuard implements CanActivate {
  constructor(
    private _session: SessionController,
    private _router: Router
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    await this._session.ready;
    return !this._session.isAuthenticated || this._router.createUrlTree([DASHBOARD_ROUTE]);
  }
}
